import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import GTMComponent from '../components/GTMComponent'
import WhyGtmMatters from '../components/WhyGtmMatters'


export default function GTMAssessmentTool() {
  return (
    <div>
      <Header1/>
      <GTMComponent/>
      <WhyGtmMatters/>
      <Footer/>
    </div>
  )
}
